const TreeNode = function (tree, id, parentId, word, text, linkText, root) {
	this.id = id;
	this.parentId = parentId;
	this.word = word;
	this.text = text;
	this.linkText = linkText;
	this.leftNeighborId = null;
	this.rightNeighborId = null;
	this.root = root;

	this.tree = tree;
};

TreeNode.prototype.parent = function () {
	return this.tree.getNode(this.parentId);
};

TreeNode.prototype.children = function () {
	return this.tree.getChildren(this.id);
};

TreeNode.prototype.isLeaf = function () {
	return this.parentId && this.children().length === 0;
};

TreeNode.prototype.childrenCount = function () {
	return this.tree.getChildren(this.id).length;
};

TreeNode.prototype.childAt = function (i) {
	let children = this.tree.getChildren(this.id);
	let child = null;

	if (children && children[i]) {
		child = children[i];
	}

	return child;
};

TreeNode.prototype.firstChild = function () {
	return this.childAt(0);
};

TreeNode.prototype.lastChild = function () {
	return this.childAt(this.childrenCount() - 1);
};

TreeNode.prototype.childrenCenter = function (UNIT) {
	var first = this.firstChild(),
		last = this.lastChild();

	return first.prelim + (last.prelim - first.prelim + UNIT) / 2;
};

TreeNode.prototype.leftNeighbor = function () {
	let neighbor = null;

	if (this.leftNeighborId) {
		neighbor = this.tree.getNode(this.leftNeighborId);
	}
	return neighbor;
};

TreeNode.prototype.rightNeighbor = function () {
	let neighbor = null;

	if (this.rightNeighborId) {
		neighbor = this.tree.getNode(this.rightNeighborId);
	}
	return neighbor;
};

TreeNode.prototype.leftSibling = function () {
	let leftNeighbor = this.leftNeighbor();
	let sibling = null;
	if (leftNeighbor && leftNeighbor.parentId === this.parentId) {
		sibling = leftNeighbor;
	}
	return sibling;
};

TreeNode.prototype.rightSibling = function () {
	let rightNeighbor = this.rightNeighbor();
	let sibling = null;
	if (rightNeighbor && rightNeighbor.parentId === this.parentId) {
		sibling = rightNeighbor;
	}
	return sibling;
};

TreeNode.prototype.leftMost = function (level, depth) {
	if (level >= depth) {
		return this;
	}
	if (this.childrenCount() === 0) {
		return undefined;
	}

	for (var i = 0, n = this.childrenCount(); i < n; i++) {
		var leftmostDescendant = this.childAt(i).leftMost(level + 1, depth);
		if (leftmostDescendant) {
			return leftmostDescendant;
		}
	}

	return undefined;
};

TreeNode.prototype.export = function () {
	return {
		id: this.id,
		parentId: this.parentId,
		word: this.word,
		text: this.text,
		linkText: this.linkText
	};
};

const GraphicTree = function (nodes = []) {
	let nodeMap = {};
	let childMap = {};
	let rootNode = null;
	// let leafTemp = {};

	nodes.forEach(n => {
		let parentId = n.parentId;
		let id = n.id;
		let node = new TreeNode(this, n.id, n.parentId, n.word, n.text, n.linkText, n.root);
		nodeMap[id] = node;
		// leafTemp[id] = true;

		if (parentId && childMap[parentId]) {
			childMap[parentId].push(node);
		} else if (parentId) {
			childMap[parentId] = [node];
		}

		if (n.root) {
			rootNode = node;
		}
	});

	// this.leaves = Object.keys(leafTemp).map(id => {
	// 	let n = nodeMap[id];
	// 	if (n.parentId) {
	// 		leafTemp[n.parentId] = false;
	// 	}
	// 	return id;
	// }).reduce((acc, id) => {
	// 	if (leafTemp[id]) {
	// 		acc[id] = true;
	// 	}
	// 	return acc;
	// }, {});

	this.rootNode = rootNode;
	this.childMap = childMap;
	this.nodeMap = nodeMap;
};

GraphicTree.prototype.getRoot = function () {
	return this.rootNode;
};

GraphicTree.prototype.getNode = function (id) {
	return this.nodeMap[id];
};

// New nodes can't be created with children
// GraphicTree.prototype.addNode = function(id, parentId, word, text, linkText) {
// 	//Create new node
// 	let node = new TreeNode(this, id, parentId, word, text, linkText);
// 	this.nodeMap[id] = node;

// 	// Add to tree
// 	if (this.childMap[parentId]) {
// 		this.childMap[parentId].push(node);
// 	} else {
// 		this.childMap[parentId] = [node];
// 	}
// 	return node;
// };

// GraphicTree.prototype.deleteNode = function(id) {
// 	if (id === this.rootNode.id) return null;

// 	let node = this.getNode(id);
// 	delete this.nodeMap[id];
// 	let filteredChildren = this.childMap[node.parentId].filter(child => {
// 		return child.id !== id;
// 	});
// 	this.childMap[node.parentId] = filteredChildren;

// 	return node;
// };

// GraphicTree.prototype.updateNode = function(id, parentId, word, text, linkText) {
// 	let node = this.deleteNode(id);
// 	if (node) {
// 		node = this.createNode(id, parentId, word, text, linkText);
// 	}
// 	return node;
// };

GraphicTree.prototype.getChildren = function (id) {
	let children = [];
	if (this.childMap && this.childMap[id]) {
		children = [...this.childMap[id]];
	}
	return children;
};

GraphicTree.prototype.getKeys = function () {
	return Object.keys(this.nodeMap);
};

GraphicTree.prototype.export = function () {
	return Object.keys(this.nodeMap).map(id => {
		return this.getNode(id).export();
	});
};

module.exports = GraphicTree;
